module.exports = __webpack_public_path__ + "img/popfm_pic7.d1d8c107.png";